module.exports = __webpack_public_path__ + "img/about5.88fcd161.png";